import * as React from "react";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid2";
import { Typography } from "@mui/material";
import ReactApexChart from "react-apexcharts";

const backgroundStyle = {
  backgroundImage: "url(https://i.postimg.cc/ncVG57Nx/Dashboard.png)",
  backgroundSize: "cover", // Ajusta a imagem para cobrir toda a área
  backgroundPosition: "center", // Centraliza a imagem
  height: "100vh", // Define altura total da viewport
  width: "100%", // Define a largura completa
};

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  marginTop: "5rem",
  marginLeft: "2rem",
  marginRight: "2rem",
  textAlign: "center",
  borderRadius: "1rem",
  height: "80vh" /* Altura da tela inteira */,
  gridTemplateColumns: "1fr" /* Ou ajuste conforme necessário */,
  color: theme.palette.text.secondary,
  ...theme.applyStyles("dark", {
    backgroundColor: "#1A2027",
  }),
}));

const chartData = {
  series: [
    {
      data: [400, 430, 448, 470, 540, 580, 690, 1100, 1200, 1380],
    },
  ],
  options: {
    chart: {
      type: "bar",
      height: 350,
    },
    plotOptions: {
      bar: {
        borderRadius: 4,
        borderRadiusApplication: "end",
        horizontal: true,
      },
    },
    dataLabels: {
      enabled: false,
    },
    title: {
        text: 'Visão geral do quantitativo de casos em Março'
      },
    xaxis: {
      categories: [
        "South Korea",
        "Canada",
        "United Kingdom",
        "Netherlands",
        "Italy",
        "France",
        "Japan",
        "United States",
        "China",
        "Germany",
      ],
    },
  },
};
const Dashboard = () => {
  return (
    <Grid container spacing={2} style={backgroundStyle}>
      <Grid
      wrap
        size={12}
      >
        <Item>
          <Typography
            variant="h5"
            gutterBottom
            style={{
              marginTop: "1rem",
              color: "black",
              fontWeight: "500",
              marginBottom: "0.5rem",
            }}
          >
            Dados epidemiológicos do muncípio de Canindé
          </Typography>
          <Grid container>
            <Grid mt={5} ml={1} size={12}>
              {" "}
              <ReactApexChart
                options={chartData.options}
                series={chartData.series}
                type="area"
                height={400}
              />
            </Grid>
          </Grid>
        </Item>
      </Grid>
    </Grid>
  );
};

export default Dashboard;
